import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgMaterialSymbolsImageSearch = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M5 21q-.825 0-1.412-.587T3 19V5q0-.825.588-1.412T5 3h5.6q-.5.8-.75 1.675T9.6 6.5q0 2.725 1.888 4.613T16.05 13q.525 0 1.013-.075t.962-.225L21 15.675V19q0 .825-.587 1.413T19 21zm16.55-7.6-3.1-3.1q-.525.35-1.125.525T16.05 11q-1.85 0-3.15-1.312T11.6 6.5t1.313-3.187T16.1 2t3.188 1.313T20.6 6.5q0 .675-.2 1.3t-.5 1.15L22.95 12zM16.1 9q1.05 0 1.775-.725T18.6 6.5t-.725-1.775T16.1 4t-1.775.725T13.6 6.5t.725 1.775T16.1 9M6 17h12l-3.075-4.1q-.275-.05-.562-.125T13.8 12.6L11.25 16 9 13z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMaterialSymbolsImageSearch);
const Memo = memo(ForwardRef);
export default Memo;
